var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('router-link',{attrs:{"to":{ name: 'Main' }}},[_c('img',{attrs:{"src":require("../assets/img/common/h1.svg"),"alt":"JOB Scope"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }